import { RCumLaudeAccount } from '@cumlaude/service-contract';

export function accountLabelMetAfkorting(account: RCumLaudeAccount) {
	return account.afkorting && !account.support ? `${account.naam} (${account.afkorting})` : account.naam;
}

export function getAccountZoekString(account: RCumLaudeAccount) {
	return account.naam + (account.email ?? '') + (account.afkorting ?? '');
}
